import { User, Bell, Building2, Users2, Mail, CreditCard, ListFilter, Clock, Key, Database, Calendar, Upload, Activity, Trash2, Phone } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

interface NavLeaf {
  title: string;
  id: string;
  icon: LucideIcon;
}
interface NavSection {
  section: string;
  items: NavLeaf[];
}
type NavEntry = NavLeaf | NavSection;

const settingsNavItems: NavEntry[] = [
  {
    title: "Personal details",
    id: "personal",
    icon: User,
  },
  {
    title: "Notifications",
    id: "notifications",
    icon: Bell,
  },
  {
    section: "Workspace",
    items: [
      {
        title: "Workspace details",
        id: "workspace",
        icon: Building2,
      },
      {
        title: "Members",
        id: "members",
        icon: Users2,
      },
      {
        title: "Contact Options",
        id: "contact-options",
        icon: ListFilter,
      },
      {
        title: "Custom Fields",
        id: "custom-fields",
        icon: Database,
      },
      {
        title: "Skip Options",
        id: "skip-options",
        icon: Clock,
      },
      {
        title: "Calendar",
        id: "calendar",
        icon: Calendar,
      },
      {
        title: "Call Settings",
        id: "call-settings",
        icon: Phone,
      },
      {
        title: "Senders",
        id: "senders",
        icon: Mail,
      },
      {
        title: "API Keys",
        id: "api-keys",
        icon: Key,
      },
      {
        title: "API Activity",
        id: "api-activity",
        icon: Activity,
      },
      {
        title: "Plans",
        id: "plans",
        icon: CreditCard,
      },
      {
        title: "Import History",
        id: "import-history",
        icon: Upload,
      },
      {
        title: "Deleted Contacts",
        id: "deleted-contacts",
        icon: Trash2,
      },
    ],
  },
];

interface SettingsSidebarProps {
  activePage: string;
  onPageChange: (page: any) => void;
}

export function SettingsSidebar({ activePage, onPageChange }: SettingsSidebarProps) {
  const { user } = useAuth();

  return (
    <div className="py-2">
      {/* User Email Header */}
      <div className="px-4 mb-6">
        <p className="text-sm text-muted-foreground">{user?.email}</p>
      </div>

      <nav className="space-y-6">
        {/* Personal Settings */}
        <div className="space-y-1">
          {settingsNavItems.map((item, index) => {
            if ('section' in item) {
              return (
                <div key={index} className="pt-6">
                  <div className="px-4 mb-2">
                    <h4 className="text-sm font-semibold">{item.section}</h4>
                  </div>
                  <div className="space-y-1">
                    {item.items.map((subItem) => {
                      const Icon = subItem.icon;
                      return (
                        <Button
                          key={subItem.id}
                          variant="ghost"
                          className={cn(
                            "w-full justify-start px-4",
                            activePage === subItem.id && "bg-muted"
                          )}
                          onClick={() => onPageChange(subItem.id)}
                        >
                          <Icon className="mr-2 h-4 w-4" />
                          {subItem.title}
                        </Button>
                      );
                    })}
                  </div>
                </div>
              );
            }

            const Icon = item.icon;
            return (
              <Button
                key={item.id}
                variant="ghost"
                className={cn(
                  "w-full justify-start px-4",
                  activePage === item.id && "bg-muted"
                )}
                onClick={() => onPageChange(item.id)}
              >
                <Icon className="mr-2 h-4 w-4" />
                {item.title}
              </Button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}